import { render } from "./disconnect-issue.vue?vue&type=template&id=54ccd9ff&scoped=true&ts=true"
import script from "./disconnect-issue.ts?vue&type=script&lang=ts&external"
export * from "./disconnect-issue.ts?vue&type=script&lang=ts&external"

import "./disconnect-issue.scss?vue&type=style&index=0&id=54ccd9ff&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ccd9ff"]])

export default __exports__